// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__7KCUI","underline":"Banner_underline__gpiHu"};